import { dateService, FORMATS } from '@/global/services/date'
import gridView from '@/global/components/grid/GridView.vue'
import vehicleServiceHistoryGridBlock from './VehicleServiceHistoryGridBlock.vue'
import truncatedTextDisplay from '@/global/components/TruncatedTextDisplay.vue'
import { getBooleanFromValue } from '@/global/utils/utils'
export default {
  name: 'serviceHistory',

  computed: {
    serviceHistoryConfig () {
      return {
        title: this.$t('fleet/vehicle_service.services_history'),
        key: 'serviceHistory',
        visible: getBooleanFromValue(this.permissions?.canReadVehicleServiceInterval),
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        tabContent: [
          // table view
          {
            component: this.tableGridComponent,
            apiConfig: {
              get: {
                module: 'fleet',
                route: 'vehicle-service-history',
                queryParams: {
                  vehicle_id: this.$route.params.id
                }
              }
            },
            mobileConfig: {
              title: this.$t('fleet/vehicle_service.services_history')
            },
            title: this.$t('fleet/vehicle_service.services_history'),
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: vehicleServiceHistoryGridBlock
              },
              useBorder: false
            },
            tableConfig: {
              showRowPointer: false,
              cellsConfig: {
                type: {
                  custom_display_value: (item) => {
                    return item?.type?.description ? this.$t(item.type.description) : ''
                  }
                },
                archived_state: {
                  custom_display_value: (item) => {
                    return (item?.type?.name === 'km' || item?.type?.name === 'hours') && item?.archived_state
                      ? item.archived_state + ' ' + item.unit
                      : dateService.formatFromUtc(item.start_state, FORMATS.date)
                  }
                }
              },
              headers: [
                {
                  label: this.$t('fleet/vehicle_service.service_type'),
                  key: 'type',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_service.name'),
                  key: 'name',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_service.archived_state'),
                  key: 'archived_state',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_service.archive_service_note'),
                  key: 'note',
                  always_visible: true,
                  component: truncatedTextDisplay
                }
              ],
              paginationConfig: {
                perPageOptions: [50, 100]
              },
              filtersConfig: {
                fields: [
                  {
                    key: 'type',
                    label: this.$t('fleet/vehicle_service.service_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: this.showItem?.item?.is_working_machine ? 'vehicle-service/working-machine-service-types' : 'vehicle-service/base-service-types',
                      depends_on: 'is_working_machine',
                      custom_display_value: (item) => {
                        return item?.description ? this.$t(item.description) : ''
                      },
                      returnValue: 'object'
                    },
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'name',
                    label: this.$t('fleet/vehicle_service.name'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'note',
                    label: this.$t('fleet/vehicle_service.archive_service_note'),
                    visible: true,
                    editable: true
                  }
                ]
              }
            }
          }
        ]
      }
    }
  }
}
